var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_188_29590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 44C41.0457 44 50 35.0457 50 24C50 12.9543 41.0457 4 30 4C18.9543 4 10 12.9543 10 24C10 35.0457 18.9543 44 30 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8927 41.6887C39.7211 41.6887 47.6887 33.7211 47.6887 23.8927C47.6887 14.0642 39.7211 6.09668 29.8927 6.09668C20.0642 6.09668 12.0967 14.0642 12.0967 23.8927C12.0967 33.7211 20.0642 41.6887 29.8927 41.6887Z",
    stroke: "#859395",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5647 21.3467H20.549C20.442 21.3467 20.3564 21.4323 20.3564 21.5393V26.5036C20.3564 26.6106 20.442 26.6962 20.549 26.6962H24.5647C24.6004 26.6962 24.636 26.7033 24.6646 26.7247L31.1268 30.7404C31.2552 30.8189 31.4192 30.7262 31.4192 30.5764V17.4309C31.4192 17.2811 31.2552 17.1884 31.1268 17.2668L24.6646 21.3182C24.6646 21.3182 24.6004 21.3467 24.5647 21.3467Z",
    fill: "#859395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4375 27.1742C33.4375 27.1742 34.7071 26.0045 34.6287 23.8005C34.5502 21.5965 33.4874 20.8262 33.4874 20.8262",
    stroke: "#859395",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7637 28.3506C35.7637 28.3506 37.504 26.7457 37.3971 23.7215C37.2901 20.6972 35.835 19.6416 35.835 19.6416",
    stroke: "#859395",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0381 29.735C38.0381 29.735 40.3348 27.6166 40.1922 23.6365C40.0495 19.6565 38.1308 18.2656 38.1308 18.2656",
    stroke: "#859395",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_188_29590",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_188_29590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_188_29590",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn);
export default __webpack_public_path__ + "static/media/sound_on.925de8f17efd339b98c0c222ca13ab7c.svg";
export { ForwardRef as ReactComponent };